module.exports = {
    projectId: "z88piuxo",
    dataset: "production",
};
